const transactionParams = {
    httpMethod: 'POST',
    hasQueryProps: false,
    isXCorelationEnabled: true,
    isAuthenticated: true,
    name: 'Request for Payment transaction',
};
const paymentTransactionApis = {
    paygate: {
        transactionRequest: {
            ...transactionParams,
            url: 'v1/payment-service/paymentinitiation',
        },
    },
    billdesk: {
        transactionRequest: {
            ...transactionParams,
            url: 'v1/payment-service/bill-desk/requested',
        },
    },
};
export default paymentTransactionApis;
